<template>
  <div class="auth-wrapper relative">
    <div class="w-full pt-4 pb-8 container m-auto">
      <div class="lg:w-1/2 m-auto items-center px-2 pb-6">
        <div class="flex pb-12 justify-between items-center">
          <h2 class="font-bold font-mono flex">
            <router-link class="logo bg-black no-underline text-white font-mono" to="/">/tap</router-link>
          </h2>

          
        </div>
        

        <div class="mb-12">
          <slot></slot>
        </div>
        <div class="">
          <p class="text-xs text-black pb-4">
            ©2020 Thumblab. All rights reserved.
          </p>

          <div class="flex pb-4">
            <a class="mr-4 underline text-full-blue text-xs" href="https://www.tatatap.com/privacy-policy">Privacy Policy</a>
            <a class="underline text-full-blue text-xs" href="https://www.tatatap.com/terms-of-service">Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
 };
</script>

<style scoped>
 .auth-wrapper {
   min-width: 350px;
   min-height: 500px;
 }

 .logo {
   display: flex;
   align-items: center;
   flex: 1;
   justify-content: space-between;
   font-size: 26px;
   padding:2px 10px 3px 4px;
 }

</style>
